import ReferralsDispatcher from '~/flux/dispatchers/ReferralsDispatcher';

const ReferralsActions = {
  claimReferralCode(code: string) {
    ReferralsDispatcher.handleReferralsAction({
      actionType: ReferralsDispatcher.CLAIM_REFERRAL_CODE,
      code,
    });
  },
};
export default ReferralsActions;
